export const QUERY_KEY = {
  USER: "user",
  CATEGORIES: "categories",
  CATEGORY: "category",
  IMAGES: "images",
  IMAGE: "image",
  VIDEOS: "videos",
  VIDEO: "video",
  AUDIOS: "audios",
  AUDIO: "audio",
  ADMIN_STATS: "adminStats",
  ONBOARDING_VIDEOS: "onboardingVideos",
};
